import Phaser from 'phaser';

/**
 * BootScene — minimal entry point. Currently it just hands straight off to the
 * TitleScene; it exists as the registered first scene and as the place to add
 * any future asset/texture preloading or device setup before the title.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  create(): void {
    this.scene.start('TitleScene');
  }
}
